const SIZES = {
  sm: 'size-9',
  md: 'size-8',
  lg: 'size-24'
} as const;

interface SaraAvatarProps {
  size: keyof typeof SIZES;
  className?: string;
}

export function SaraAvatar({ size, className }: SaraAvatarProps): React.ReactNode {
  return (
    <img
      src="/avatars/sara.png"
      srcSet="/avatars/sara.png 1x, /avatars/sara@2x.png 2x, /avatars/sara@3x.png 3x"
      alt="Sara"
      className={`rounded-full object-cover ${SIZES[size]} ${className ?? ''}`}
    />
  );
}
